import { BaseJob } from "src/app/types/job.type";
import { Job, Dropoff } from ".";
import { BuildServices, GroupActionSortByType } from "./generic-route-event.model";

export class Pickup extends Job {
  public type = 'pickup';
  public groupStopOrder = GroupActionSortByType.Pickup;
  constructor(value: BaseJob, dropoff: Dropoff, services: BuildServices) {
    super(value, services);
    const time = this.scheduledStart ? this.scheduledStart.toFormat('HH:mm') : '00:00';
    this.headerInfo.type = 'LABEL.pickup';
    this.phoneNumber = value.pickupPhone || value.phone || '';
    this.dropoff = dropoff;
  }
}
